import { Backdrop, Button, CircularProgress, Grid, Tooltip, Typography } from "@mui/material";
import { Downloads } from "../../helper/DownloadService";
import { useState } from "react";

function DownloadPDFButtons({ buttons, disabled = false }) { // ✅ Add disabled prop with default
    const [loading, setLoading] = useState(false);
    
    return (
        <>
            <Backdrop 
                sx={(theme) => ({ 
                    backgroundColor: "#fff", 
                    color: '#000', 
                    zIndex: theme.zIndex.drawer + 1 
                })} 
                open={loading}
            >
                <div>
                    <CircularProgress color="inherit" />
                </div>
                <Typography variant="h4" component="div" sx={{ ml: 2 }}>
                    Downloading
                </Typography>
            </Backdrop>
            
            <Grid sx={{ mt: 2 }} container>
                {buttons.map(({ label, icon: Icon, ref, pdfComponent: PdfComponent, fileName, data, orientation }, index) => (
                    <Grid 
                        sx={{
                            padding: '5px', 
                            textAlign: "center", 
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }} 
                        xs={6} 
                        sm={6} 
                        md={12 / buttons.length} 
                        lg={12 / buttons.length} 
                        xl={12 / buttons.length} 
                        key={index}
                    >
                        {/* Hidden PDF Generation */}
                        <div style={{ display: 'none' }}>
                            <div ref={ref}>
                                <PdfComponent {...data}></PdfComponent>
                            </div>
                        </div>

                        {/* Button with Tooltip */}
                        <Tooltip 
                            title={disabled ? "Mohon tunggu, sedang memuat data..." : "Klik untuk download"}
                            arrow
                        >
                            <span style={{ width: '100%' }}> {/* ✅ Wrap in span for disabled tooltip to work */}
                                <Button
                                    onClick={() => {
                                        if (!disabled) {
                                            const element = ref.current;
                                            setLoading(true);
                                            Downloads.GeneratePDF(element, fileName, orientation, setLoading);
                                        }
                                    }}
                                    fullWidth
                                    disabled={disabled} // ✅ Use disabled prop
                                    sx={{
                                        backgroundColor: disabled ? '#ccc' : '#e96726', // ✅ Gray when disabled
                                        '&:hover': {
                                            backgroundColor: disabled ? '#ccc' : '#d55515',
                                        },
                                        '&:disabled': {
                                            color: '#666',
                                            cursor: 'not-allowed'
                                        }
                                    }}
                                    variant="contained"
                                    color="primary"
                                    startIcon={disabled ? <CircularProgress size={20} color="inherit" /> : <Icon />} // ✅ Show spinner when disabled
                                >
                                    {label}
                                </Button>
                            </span>
                        </Tooltip>
                    </Grid>
                ))}
            </Grid>
        </>
    );
}

export default DownloadPDFButtons;